import styled from 'styled-components';

export const Container1 = styled.div`
  width:490px;
  height:250px;
  background-color:white;
  border-radius:10px;
  margin-left:10px;
.top{
    display:flex;
    align-items:center;
    width:100%;
    height:50px;
    border-bottom:3px solid #e9ecef;

}
.title{
    font-family: SFProDisplay;
font-size: 12px;
line-height: 14px;
color: #2D3A45;
margin-left:24px;
}
.date{
    font-family: SFProDisplay;
font-size: 12px;
line-height: 14px;
color: #2D3A45;
margin-left:100px;
}
.Con{
    width: 24px;
height: 24px;
background: white;
border:3px solid #EDEFF3;
border-radius: 22.4px;
display:flex;
align-items:center;
justify-content:center;
margin-left:24px;

}
.icon{
  width:10px;
  height:10px;

}
`
export const Container2 = styled.div`
  width:490px;
  height:250px;
  background-color:white;
  border-radius:10px;
  margin-left:10px;
.top{
    display:flex;
    align-items:center;
    width:100%;
    height:50px;
    border-bottom:3px solid #e9ecef;

}
.title{
    font-family: SFProDisplay;
font-size: 12px;
line-height: 14px;
color: #2D3A45;
margin-left:24px;
}
.date{
    font-family: SFProDisplay;
font-size: 12px;
line-height: 14px;
color: #2D3A45;
margin-left:100px;
}
.Con{
    width: 24px;
height: 24px;
background: white;
border:3px solid #EDEFF3;
border-radius: 22.4px;
display:flex;
align-items:center;
justify-content:center;
margin-left:10px;

}
.icon{
  width:10px;
  height:10px;

}
`
export const Container3 = styled.div`
width:490px;
  height:250px;
  background-color:white;
  border-radius:10px;
  margin-left:10px;
  margin-top:10px;

.top{
    display:flex;
    align-items:center;
    width:100%;
    height:50px;
    border-bottom:3px solid #e9ecef;

}
.title{
    font-family: SFProDisplay;
font-size: 12px;
line-height: 14px;
color: #2D3A45;
margin-left:24px;
}
.date{
    font-family: SFProDisplay;
font-size: 12px;
line-height: 14px;
color: #2D3A45;
margin-left:130px;
}
.Con{
    width: 24px;
height: 24px;
background: white;
border:3px solid #EDEFF3;
border-radius: 22.4px;
display:flex;
align-items:center;
justify-content:center;
margin-left:10px;

}
.icon{
  width:10px;
  height:10px;

}
.mybarchart{
    width:200px;
    height:6px;
   background: #F9FAFB;
border-radius: 5.5px;
margin-left:49px;
}
.insider1{
   width: 99px;
height: 6px; 
background: #FCB600;
border-radius: 5.5px;
transition: 1s all;
}
.persent{
    font-family: SFProDisplay;
font-size: 10px;
line-height: 12px;
margin-left:12px;
margin-right:24px;

color: #2D3A45;
}
.circle{
height: 8px;
width: 8px;
background: #FCB600;
padding:0;
margin:0;
margin-left:24px;
}
.type{
    font-family: SFProDisplay;
font-size: 12px;
line-height: 14px;
color: #2D3A45;
margin-left:16px;
}
`